import React from 'react';
import './Loading.scss';
import { Image } from 'react-bootstrap';
import LoadingIcon from '../../assets/images/loading.gif';
import NoDataIcon from '../../assets/images/nodata.svg';

function NoDataPage() {
  return (
    <div className="loading-area">
      <Image src={NoDataIcon} className=""></Image>
    </div>
  );
}

export default NoDataPage;
